import { removerSaltosLines } from '../utils/removerSaltosLinea'

const queryDetailPax = `
$expand=EstadoFisicoReserva($select=EstadoFisicoReservaId,Nombre),ReservaCentralizada($expand=Proveedor($select=RazonSocial,NombreComercial,NombreCompleto);$select=Proveedor),ReservaCentralizadaBoletosDetalle($select=ReservaCentralizadaBoletosDetalleId,FechaEmision,NumeroBoletoAtado,AsignacionPasajero,RecordVuelo,NumeroBoleto;$expand=AsignacionPasajero($select=Pasajero;$expand=Pasajero($select=Identificacion,Nombre,Apellido,FechaNacimiento,Nacionalidad;$expand=TipoPasajero($select=Valor)))) 
&$expand=Actividad(
  $select=Producto,Ruta;
  $expand=Componente($select=Nombre),ActividadMaestra($select=ActividadMaestraId,BookingId,BookingCode),Producto($select=Nombre),Comentario($expand=TipoComentario($select=Nombre,Valor);$select=TipoComentario,TipoComentarioId,Comentario1)
)
&$filter=ReservaCentralizadaId in ( {IDs} )
`

export const getQueryReservaDetallePaxOData = (detailIds: number[]): string => {
  const query = queryDetailPax.replace('{IDs}', detailIds.join(',') ?? '')

  return removerSaltosLines(query).trim()
}
